import SmoothScroll from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Founder } from "@/components/site/Founder";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { InclusionSupport } from "@/components/site/InclusionSupport";
import { OtherServices } from "@/components/site/OtherServices";
import { Outcomes } from "@/components/site/Outcomes";
import { Impact } from "@/components/site/Impact";
import { Testimonials } from "@/components/site/Testimonials";
import { Booking } from "@/components/site/Booking";
import { Footer } from "@/components/site/Footer";
import { BookletFlipbook } from "@/components/site/BookletFlipbook";
import { LiquidGlassBackground } from "@/components/site/LiquidGlassBackground";

export default function Landing() {
  return (
    <SmoothScroll>
      <div className="relative isolate min-h-screen text-ink overflow-x-clip">
        <LiquidGlassBackground />
        <div className="relative z-10">
          <Nav />
          <main>
            <Hero />
            <Ribbon />
            <Founder />
            <Services />
            <InclusionSupport />
            <Manifesto />
            <Impact />
            <OtherServices />
            <Outcomes />
            <Testimonials />
            <Booking />
          </main>
          <Footer />
          <BookletFlipbook />
        </div>
      </div>
    </SmoothScroll>
  );
}
